import * as React from 'react';
import gql from 'graphql-tag';
import { ChildProps, graphql } from 'react-apollo';
import {
  CoreShopSettingsCountries,
  core_apimessages_Country as Country,
} from '../schemas/rql';
import ShopSettingsVatAddVatIdButton from './shop_settings_add_vat_id_button';
import ShopSettingsVatIds from './shop_settings_vat_ids';
import { COUNTRY_CODES } from './shop_settings_vat_supported_countries';

type Props = ChildProps<any, CoreShopSettingsCountries.Query>;

export function ShopSettingsVatLayout({ data }: Props) {
  const { countries } = data.countries;
  const vatCountries = filterVatCountries(countries);
  const countryOptions = createCountryOptions(vatCountries);

  return (
    <div>
      <ShopSettingsVatIds countryOptions={countryOptions} />
      <ShopSettingsVatAddVatIdButton countryOptions={countryOptions} />
    </div>
  );
}

export function filterVatCountries(countries: Country[]) {
  return countries.filter(country => COUNTRY_CODES.includes(country.countryCode));
}

export function createCountryOptions(countries: Country[]) {
  return countries.map(country => ({ value: country.countryCode, text: country.name }));
}

const COUNTRIES_QUERY = gql`
  query Core_ShopSettings_Countries {
    countries {
      countries {
        countryCode
        name
      }
    }
  }
`;

const withQuery = graphql<any, CoreShopSettingsCountries.Query>(COUNTRIES_QUERY);

export default withQuery(ShopSettingsVatLayout);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shop_settings_vat_layout.tsx